import type { CommonProps } from '@/@types/common'

/**
 * Pre-login layout wrapper.
 *
 * Historically this gated auth routes through `AuthLayout` (the
 * starter-kit Side/Simple/Split shells with hardcoded
 * max-w-[380px] form columns + a static auth-side-bg.png on the
 * right). Claude Design's new auth pages provide their own full-page
 * two-column AuthShell with the Equation / paper / LML brand panel,
 * so the old wrapper is now both redundant and counterproductive
 * (it constrained the form to 380px and rendered a broken image
 * placeholder where AuthShell expects to draw the brand panel).
 *
 * This component is now a passthrough; remove it entirely once the
 * route layer no longer references it.
 */
const PreLoginLayout = ({ children }: CommonProps) => {
    return <div className="flex flex-auto flex-col min-h-screen">{children}</div>
}

export default PreLoginLayout
